import { render, staticRenderFns } from "./CsCenter.vue?vue&type=template&id=daffdb5c&scoped=true&"
import script from "./CsCenter.vue?vue&type=script&lang=js&"
export * from "./CsCenter.vue?vue&type=script&lang=js&"
import style0 from "./CsCenter.vue?vue&type=style&index=0&id=daffdb5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daffdb5c",
  null
  
)

export default component.exports